import { isCardQuizCard, isCardSurveyCard } from 'src/model/card'
import { resolveFont } from 'src/utils/workspace-logo'

export const createCourseTemplate = (courseCards, landingPageData, display) => {
  if (!landingPageData) {
    return ''
  }

  // Get localized strings
  const quiz = landingPageData.localizations?.quiz || 'Quiz'
  const feedback = landingPageData.localizations?.feedback || 'Feedback'

  // Process sections and group quiz/survey cards
  const processedSections = courseCards.map(section => {
    const groupedCards = []
    let currentGroup = null

    section.cards.forEach(card => {
      const isQuiz = isCardQuizCard(card.type)
      const isSurvey = isCardSurveyCard(card.type)

      // Check if we should add to current group or create new one
      if (currentGroup && currentGroup.isQuiz && isQuiz) {
        // Add to existing quiz group
        currentGroup.cards.push(card)
      } else if (currentGroup && currentGroup.isSurvey && isSurvey) {
        // Add to existing survey group
        currentGroup.cards.push(card)
      } else {
        // Create new group
        currentGroup = {
          cards: [card],
          isQuiz: isQuiz,
          isSurvey: isSurvey,
        }
        groupedCards.push(currentGroup)
      }
    })

    return {
      ...section,
      groupedCards,
    }
  })

  return `
    <div class="course-container">
      <div class="course-inner-container">
        <div class="course-sections-container">
          ${processedSections
            .map(
              section => `
            <div class="course-section">
              <div class="section-header">
                <div class="section-title">
              <p>  ${section.name}</p>
                </div>
              </div>

              <div class="section-divider-container">
                <hr class="section-divider" />
              </div>

              <div class="cards-container">
                ${section.groupedCards
                  .map(group => {
                    // Determine the title for the group
                    const groupTitle = group.isQuiz
                      ? quiz
                      : group.isSurvey
                      ? feedback
                      : group.cards[0]?.title || 'Untitled Card'

                    return `
                  <div class="card-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="rgba(145, 158, 171, 0.32)"/>
                    </svg>
                    <div class="card-title">
                       <p> ${groupTitle} </p>
                    </div>
                  </div>
                `
                  })
                  .join('')}
              </div>
            </div>
          `,
            )
            .join('')}
        </div>


        ${
          !display
            ? `
        <div class="start-button-container">
          <div class="start-button" style="background: ${
            landingPageData.primaryColor
          } !important; font-family: ${resolveFont(landingPageData.font)} !important">
            <div class="start-button-text">
              ${
                landingPageData.localizations
                  ? landingPageData.localizations.startButton
                  : 'START COURSE'
              }
            </div>
          </div>
        </div>
        `
            : ''
        }
      </div>
    </div>
  `
}
